import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import "./ExistingProforma.css";
import { yupResolver } from "@hookform/resolvers/yup";
import { ExistingProformaSchema } from "../../yup";
import { useExistingProformaMutation } from "../../services/proformaApi";
import Loader from "../Loader";
import { showNotification } from "../../services/showNotification";
import { tracker } from "../../services/mixpanel";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
const ExistingProforma = ({
  onProformaCheckResult,
  setProformaId,
  setContactEmail,
  proformaId,
  contactEmail,
}: {
  onProformaCheckResult: (result: ExistingProformaResponse, id: string) => void;
  setProformaId: (proformaId: string) => void;
  setContactEmail: (contactEmail: string) => void;
  proformaId?: string;
  contactEmail?: string;
}) => {
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors, isDirty },
  } = useForm<ExistingProformaForm>({
    resolver: yupResolver(ExistingProformaSchema),
    defaultValues: {
      proformaId: proformaId ? proformaId : "",
      contactEmail: contactEmail ? contactEmail : "",
    },
  });
  const username = useSelector(
    (state: RootState) => state.proformaUser?.name
  );

  const hasStarted = useRef(false);

  const [existingProforma, { isLoading: isExistingProformaLoading }] =
    useExistingProformaMutation();
  const onSubmit = async (data: ExistingProformaForm) => {
    tracker.proforma.finalizeProformaFormSubmitted();
    try {
      const response = await existingProforma({
        proformaId: data.proformaId,
        contactEmail: data.contactEmail,
      }).unwrap();
      console.log(response);
      setProformaId(data.proformaId);
      setContactEmail(data.contactEmail);
      await onProformaCheckResult(response.data, data.proformaId);
    } catch (error: any) {
      console.log(error);
      const message = error?.data?.message ?? "An error occurred during search.";
      tracker.proforma.finalizeProformaFailed(username, message);
      showNotification("error", message);
    }
  };

  const onError = () => {
    tracker.proforma.finalizeProformaFormError(username);
  };

  useEffect(() => {
    if (isDirty && !hasStarted.current) {
      hasStarted.current = true;
      tracker.proforma.finalizeProformaFormStarted();
    }
  }, [isDirty]);
  return (
    <div className="existing-proforma-wrapper">
      <h2 className="proforma-title">FINALIZE PROFORMA</h2>
      <form onSubmit={handleSubmit(onSubmit, onError)} className="proforma-form" noValidate>
        <div className="form-group">
          <label>Contact Email Address:</label>
          <input
            type="email"
            placeholder="Enter contact email"
            {...register("contactEmail", { required: "Email is required" })}
          />
          {errors.contactEmail && (
            <span className="error-msg">{errors.contactEmail.message}</span>
          )}
        </div>

        <div className="form-group">
          <label>Proforma Id:</label>
          <input
            type="text"
            placeholder="Enter Proforma Id"
            readOnly={!!proformaId}
            {...register("proformaId", {
              required: "Proforma Id is required",
            })}
          />
          {errors.proformaId && (
            <span className="error-msg">{errors.proformaId.message}</span>
          )}
        </div>

        <button type="submit" className="submit-btn">
          {isExistingProformaLoading ? (
            <Loader isLoading={isExistingProformaLoading} size={22} />
          ) : (
            "Submit"
          )}
        </button>
      </form>
    </div>
  );
};

export default ExistingProforma;
